import angular from "angular";
import { SelectMachineModalService, vsServiceName } from "./service";
import {
  selectMachineModalComponentOptions,
  vsComponentName,
} from "./component";

export const vsModuleName = "SlotTrak.Machines.Shared.SelectMachineModal";

angular
  .module(vsModuleName, [])
  .service(vsServiceName, SelectMachineModalService)
  .component(vsComponentName, selectMachineModalComponentOptions);
